import {
  INTERN_INFO_ID,
  JOB_INFO_ID,
  JOB_INFO_SECTION_INDEX,
  PREFERENCE_ID,
} from '../../entities/reports/constants';
import type {
  GetEntrySheetResponse,
  GetSelectionReportResponse,
} from '../../repositories/reportsRepository';

export function getDisplaySectionList(
  selectionReport: GetSelectionReportResponse | undefined,
) {
  return (
    selectionReport?.sectionList.filter(
      (section) =>
        ![JOB_INFO_ID, INTERN_INFO_ID, PREFERENCE_ID].includes(section.id) &&
        section.questionAnswerList.length > 0,
    ) ?? []
  );
}

export function getDisplaySectionNameList(
  selectionReport: GetSelectionReportResponse | undefined,
): string[] {
  const jobInfoSectionIndex =
    selectionReport?.sectionList.map((section) => section.sectionName)[
      JOB_INFO_SECTION_INDEX
    ] ?? '';

  const preferenceSectionIndex =
    selectionReport?.sectionList.find(
      (section) =>
        section.id === PREFERENCE_ID && section.questionAnswerList.length > 0,
    )?.sectionName ?? '';

  const laterSections =
    getDisplaySectionList(selectionReport).map(
      (section) => section.sectionName,
    ) ?? [];

  return [
    jobInfoSectionIndex,
    preferenceSectionIndex,
    '選考について',
    ...laterSections,
  ].filter(Boolean);
}

export function getDisplaySectionNameListForEntrySheet(
  entrySheet: GetEntrySheetResponse | undefined,
): string[] {
  const answerNameList =
    entrySheet?.questionAnswers.map((_, index) => `設問${index + 1}`) || [];
  return ['基本情報', ...answerNameList];
}
